export default __webpack_public_path__ + "static/media/Nihilistic Armbands.704ad65f.jpg";